module.exports = __webpack_public_path__ + "img/phil_hero_desktop.c1c11391.png";